import type { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

export const SelectionsPanelContainer: FC<PropsWithChildren> = ({
  children = undefined,
}) => {
  return (
    <div
      className={twMerge(
        `z-[200] block h-min w-full antialiased transition-all duration-300 ease-in-out sm:top-0 sm:w-[264px]`
      )}
    >
      {children}
    </div>
  );
};
